import React from "react"
import Modal from "../../Components/Modal/Modal"
import ConfirmButton from "../../Components/Buttons/ConfirmButton"
import CancelButton from "../../Components/Buttons/CancelButton"

function TermsAndConditionsTeacher(props) {
  return (
    <Modal
      id="terms-co-box"
      header="EDUCATION PROFESSIONAL Ts & Cs"
      onClose={props.onClose}
      show={props.show}
    >
      <p className="terms-co-box-subtitle">
        ReadyTeacher provides the ReadyTeacher digital recruitment platform that connects registered teaching
        and training providers and with specialist education professionals.
      </p>
      <ol>
        <h4>
          <li><strong>TERMS AND CONDITIONS OF USE</strong></li>
        </h4>
        <p>
          <ol>
            <li>
              The Education Professional agrees that ReadyTeacher may propose Placements
              on their behalf.
            </li>
            <li>
              The Education Professional agrees that the Education Provider (Customer) may request
              their services directly by perusing and selecting their published Profile/Resume.
            </li>
            <li>
              Where the Education Professional accepts a Placement, the Education Professional agrees that:
              <ol>
                <li>
                  ReadyTeacher shall charge the customer the Education Professional Rate and collect and
                  deposit Superannuation/Retirement Contributions on their behalf, according to local laws
                  of the Country of Residence for taxation purposes of the Education Professional; and
                </li>
                <li>
                  The Education Professional will provide accurate Bank Account information for payment of wages owing.
                </li>
              </ol>
            </li>
            <li>
              ReadyTeacher will make Placements:
              <ol>
                <li>
                  Via the Platform; and
                </li>
                <li>
                  By dealing directly with the Education Professional.
                </li>
              </ol>
            </li>
            <li>
              To use the Platform, the Education Professional must also accept the Terms of Service when registering on the platform.
            </li>
            <li>
              Where the Education Professional is a resident for taxation purposes of a Country that requires the
              Employer/Contractor (ReadyTeacher) to withhold tax payments, then the Education Professional must provide
              an appropriate and valid Taxation Identification Number to ReadyTeacher via the Platform.
            </li>
            <li>
              As a material condition of this Agreement, the Education Professional warrants
              that:
              <ol>
                <li>
                  All information it submits to ReadyTeacher, or an Education Provider (customer), is
                  true and accurate to the best of the Education Professional's knowledge,
                  including with regard to the Education Professional's experience and work
                  history;
                </li>
                <li>
                  It is holds all current qualifications and licences it
                  represents as holding; and
                </li>
                <li>
                  It will only accept Placements for which it is suitably
                  qualified and experienced.
                </li>
              </ol>
            </li>
          </ol>
        </p>

        <h4>
          <li><strong>RELATIONSHIP</strong></li>
        </h4>
        <p>
          <ol>
            <li>
              The Education Professional agrees and acknowledges that:
              <ol>
                <li>
                  The Education Professional may be an Employee or Independent Contractor of ReadyTeacher,
                  depending on employment legislation relating to their Country of Residence,
                  and will be an Employee within Australia if in residence of Australia;
                </li>
                <li>
                  The ReadyTeacher Platform acts as a booking manager for the purpose of introducing the
                  Education Professional to hiring Education Providers (Customers);
                </li>
                <li>
                  The Education Professional is not a direct employee of the hiring Education Provider (Customer).
                </li>
              </ol>
            </li>
            <li>
              The Education Professional agrees that it is solely responsible for the provision of its services
              to the Education Provider (Customer), and any feedback resulting from the Placement;
            </li>
            <li>
              ReadyTeacher is under no obligation to ensure that an Education Professional receives a Placement,
              and makes no warranty or representation that:
              <ol>
                <li>
                  The Education Professional will receive a Placement; or
                </li>
                <li>
                  The Placement will last for a particular duration without disruption; or
                </li>
                <li>
                  Further Placement will be guaranteed.
                </li>
              </ol>
            </li>
            <li>
              ReadyTeacher accepts no responsibility for any Placement that is cancelled, and agrees to apply
              for a cancellation fee to be paid to the Education Professional by the Education Provider (customer).
            </li>
            <li>
              In no event may an Education Professional subcontract a Placement to a
              third-party.
            </li>
          </ol>
        </p>
        <h4>
          <li>
            <strong>PAYMENT OF SALARIES AND SUPERANNUATION</strong>
          </li>
        </h4>
        <p>
          <ol>
            <li>
              ReadyTeacher agrees and acknowledges that:
              <ol>
                <li>
                  The Education Professional’s salary will be deposited fortnightly according to the
                  Pay Schedule (calendar) as provided by ReadyTeacher’s Finance Manager;
                </li>
                <li>
                  The Education Professional’s superannuation will be deposited quarterly
                  according to the schedule provided by the Australian Taxation Office (ATO);
                </li>
                <li>
                  The Education Professional is required to refund any overpayment of wages for work not performed.
                </li>
              </ol>
            </li>
          </ol>
        </p>
        <h4>
          <li>
            <strong>INTRODUCTIONS, EXCLUSIVITY AND ONGOING PLACEMENTS</strong>
          </li>
        </h4>
        <p>
          <ol>
            <li>
              In the event that an Education Professional is first introduced to an Education Provider (customer) via the
              ReadyTeacher Platform, this is considered as a ReadyTeacher Introduction.
            </li>
            <li>
              In the event that an Education Professional is first introduced to an Education Provider (customer) via
              another recruitment platform or by self-introduction (cold-calling or CV drop-in),
              this is considered as a Self-introduction.
            </li>
            <li>
              In the event of a ReadyTeacher Introduction (item 3.1), whereby a
              successfully matched placement has occurred and the Parties wish
              to continue their relationship outside the Platform, the Education Provider (Customer)
              is required to observe a minimum 130-hour to maximum 180-hour Employee
              Trial Period. The Education Provider (customer) should not use the ReadyTeacher Platform
              to source ongoing staff at a cost to ReadyTeacher.
            </li>
            <li>
              In the event whereby a successfully matched placement has occurred
              and the Parties wish to continue their relationship outside the
              Platform, and the Education Provider (Customer) and Education Professional fail to complete a
              130-hour to 180-hour Employee Trial Period, both parties will be
              excluded from the Platform without appeal.
            </li>
            <li>
              Upon conclusion of the Employee Trial Period, there is no further cost to either
              Education Professional or Education Provider (Customer) should they wish to contract directly.
            </li>
          </ol>
        </p>
        <h4>
          <li><strong>LIABILITY AND INDEMNITY</strong></li>
        </h4>
        <ol>
          <p>
            <li>
              The Education Professional agrees to indemnify ReadyTeacher for any loss,
              damage, cost or expense that ReadyTeacher may suffer or incur as a
              result of or in connection with:
              <ol>
                <li>
                  The Education Professional's conduct on a Placement; and
                </li>
                <li>
                  The Education Professional's breach of this Agreement and/or the Terms of
                  Service.
                </li>
              </ol>
            </li>
            <li>
              The Education Provider is covered by ReadyTeacher’s Public Liability Insurance.
            </li>
            <li>
              Professional Indemnity Insurance may be included in Platform registration in future. The Education
              Provider is advised to insure themselves against Professional Indemnity in the event that their
              conduct whilst delivering professional services come into question.
            </li>
          </p>
        </ol>
      </ol>
      <br />
      {/* large screen */}
      <div className="row mt-5">
        <div className="col-md-6 mb-2 mb-md-0">
          <CancelButton onClick={props.onCancel}>Cancel</CancelButton>
        </div>
        <div className="col-md-6">
          <ConfirmButton onClick={props.onConfirm}>Accept</ConfirmButton>
        </div>
      </div>

      {/* small screen */}
      {/* <div className="row small-screen-appear d-none" style={{ margin: '0px' }}>
        <div className="col-md-6 register-alert-button mb-1">
          <ConfirmButton onClick={props.onCancel}>Accept</ConfirmButton>
        </div>
        <div className="col-md-6">
          <CancelButton onClick={props.onConfirm}>Cancel</CancelButton>
        </div>
      </div> */}
      <br />
    </Modal>
  )
}

export default TermsAndConditionsTeacher
